export default "__VITE_ASSET__By_nRMnr__"